/**
 * Smooth Scroll — GSAP ScrollSmoother
 *
 * Site-wide smooth scrolling using ScrollSmoother + ScrollTrigger.
 * Requires #page-wrapper (outer) and #page (inner) in the DOM.
 * Respects prefers-reduced-motion.
 *
 * The header sits outside #page but inside #page-wrapper. ScrollSmoother
 * calculates scroll distance from #page height alone, so the footer gets
 * clipped by the header's height. We compensate by adding bottom padding
 * to #page equal to the header height, then refreshing ScrollTrigger.
 */
( function () {

	function compensateHeaderHeight() {
		var header  = document.querySelector( '.site-header' );
		var content = document.querySelector( '#page' );
		if ( ! header || ! content ) {
			return;
		}
		content.style.paddingBottom = header.offsetHeight + 'px';
		ScrollTrigger.refresh();
	}

	function initScrollSmoother() {
		if ( typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof ScrollSmoother === 'undefined' ) {
			return;
		}

		gsap.registerPlugin( ScrollTrigger, ScrollSmoother );

		// Skip ScrollSmoother on mobile/touch — native scrolling is already
		// smooth on touch devices, and disabling it lets window.scrollY,
		// scroll events, and sticky positioning work reliably.
		if ( window.innerWidth <= 1200 ) {
			return;
		}

		var reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

		window.scrollSmoother = ScrollSmoother.create( {
			wrapper: '#page-wrapper',
			content: '#page',
			smooth: reducedMotion ? 0 : 1.5,
			effects: true,
		} );

		// Compensate after full page load (images, fonts settled).
		window.addEventListener( 'load', compensateHeaderHeight );

		// Re-compensate on resize in case header height changes (e.g. mobile).
		var resizeTimer;
		window.addEventListener( 'resize', function () {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( compensateHeaderHeight, 200 );
		} );
	}

	function waitForGSAP() {
		if (
			typeof gsap !== 'undefined' &&
			typeof ScrollTrigger !== 'undefined' &&
			typeof ScrollSmoother !== 'undefined'
		) {
			initScrollSmoother();
		} else {
			setTimeout( waitForGSAP, 50 );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', waitForGSAP );
	} else {
		waitForGSAP();
	}

} )();
